import "select2";
import jquery from "jquery";

window.jQuery = jquery;
window.$ = jquery;

function init() {
    $(".gfield_select").each(function () {
        $(this).select2({
            minimumResultsForSearch: Infinity,
            width: "100%",
        });
    });

    $(".input_phone input").on("click", function () {
        for (let i = 0; i < this.value.length; i++) {
            if (this.value[i] == "_") {
                setCaretPosition(this, i);
                break;
            }
        }
    });
}

function setCaretPosition(ctrl, pos) {
    // Modern browsers
    if (ctrl.setSelectionRange) {
        ctrl.focus();
        ctrl.setSelectionRange(pos, pos);

        // IE8 and below
    } else if (ctrl.createTextRange) {
        var range = ctrl.createTextRange();
        range.collapse(true);
        range.moveEnd("character", pos);
        range.moveStart("character", pos);
        range.select();
    }
}

jQuery(document).ready(function () {
    jQuery(document).on("gform_post_render, gform_page_loaded", function () {
        init();
    });

    init();

    /* eslint-disable */
    if (gform) {
        gform.addFilter('gform_datepicker_options_pre_init', function (optionsObj, formId, fieldId) {
            if (formId == 4 && fieldId == 13 || formId == 5 && fieldId == 13) {
                optionsObj.minDate = 0;
            }
            return optionsObj;
        });
    }
    /* eslint-enable */
});
